(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-list"] && !window.DesignMode) return;
  try {
    
const faqQuestions = document.querySelectorAll('.faq-list-item__question');
faqQuestions.forEach(e => {
  e.addEventListener("click", function() {
    for (ele of faqQuestions) {
      if (ele == e) {
        e.classList.toggle("active");
      } else {
        ele.classList.remove("active");
      }
    }
  })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-accordion"] && !window.DesignMode) return;
  try {
    

  const accordions = Array.from(document.querySelectorAll('.accordion'))
  accordions.forEach(accordion => {
    const accordionHeader = accordion.querySelector('.accordion__header')
    accordionHeader.addEventListener('click', event => {
      accordions.forEach(accordion => {
        accordion.classList.remove('open')
      })
      accordion.classList.toggle('open')
    })
  })

  
  } catch(e) { console.error(e); }
})();
})();
